var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "PU",
        visible: _vm.dialogVisible,
        "append-to-body": true,
        width: "520px",
        "show-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "柜号", prop: "containerNumber" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择柜号" },
                      model: {
                        value: _vm.form.containerNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "containerNumber", $$v)
                        },
                        expression: "form.containerNumber",
                      },
                    },
                    _vm._l(_vm.containerNumberOption, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "PU#", prop: "puNo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请输入PU#" },
                    model: {
                      value: _vm.form.puNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "puNo", $$v)
                      },
                      expression: "form.puNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "PU日期", prop: "puDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期时间",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.puDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "puDate", $$v)
                      },
                      expression: "form.puDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialogfooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v(" 确 定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }